import { cloneDeep } from 'lodash';

import {
  BANKING_FEATURES,
  FREQUENCY,
  PRODUCT_PREFERENCES,
  REFINANCING_REASONS,
  REPAYMENT_OPTIONS,
  REPAYMENT_TYPE,
  REPAYMENT_TYPE_DETAILS,
} from '@funnels/constants';
import { ProductPreferences } from '@funnels/types';

export const PRODUCT_PREFERENCES_MOCK_DATA: ProductPreferences[] = [
  {
    id: 'productPreferences-1',
    applicationId: 'application-1',
    clientId: 'productPreferences-1-client',
    repaymentTypeDetails: {
      type: REPAYMENT_TYPE.PrincipalAndInterest,
      details: [
        REPAYMENT_TYPE_DETAILS.InterestOnlyDueToVariableAndUnpredictableIncome,
        REPAYMENT_TYPE_DETAILS.MaximiseBorrowingCapacityWithDepositOrAmountOfEquityAccessible,
      ],
    },
    otherPreferences: 'reprehenderit laborum',
    extraRepayments: {
      opted: true,
      amount: 300,
      frequency: FREQUENCY.FORTNIGHTLY,
    },
    loanTerm: 20,
    repaymentOptions: [
      {
        option: REPAYMENT_OPTIONS.Downsize,
        description: 'aute labore',
      },
    ],
    refinanceReasons: [
      {
        reason: REFINANCING_REASONS.PayOffLoanFasterWithALowerInterestRate,
      },
      {
        reason: REFINANCING_REASONS.DecreaseRepayments,
        description: 'anim non ullamco nulla',
      },
    ],
    lenderBankingFeatures: [BANKING_FEATURES.ApplePay, BANKING_FEATURES.BranchAccess, BANKING_FEATURES.CreditCard],
    reason: [
      PRODUCT_PREFERENCES.HaveSetRepayments,
      PRODUCT_PREFERENCES.UseSavingsOrSalaryToReduceInterest,
      PRODUCT_PREFERENCES.AbilityToPayOffLoanSooner,
    ],
  },
];

export const getMockProductPreferences = (): ProductPreferences[] => cloneDeep(PRODUCT_PREFERENCES_MOCK_DATA);
